var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.link_loading || _vm.error_loading
    ? _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { staticClass: "text-center" },
                [
                  _vm.error_loading
                    ? _c(
                        "div",
                        {
                          staticClass: "display-1",
                          staticStyle: { color: "#808080" },
                        },
                        [_vm._v(" Не удалось загрузить страницу... ")]
                      )
                    : _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          size: "90",
                          width: "3",
                          color: "dark",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "" } },
            [
              _c(
                "v-toolbar-title",
                [
                  _c("v-icon", { attrs: { large: "", left: "" } }, [
                    _vm._v(_vm._s(_vm.icon_bag)),
                  ]),
                  _vm._v(" " + _vm._s(_vm.opened_link.place) + " "),
                ],
                1
              ),
            ],
            1
          ),
          _vm.opened_link.description
            ? _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-alert",
                            { attrs: { outlined: "", type: "info" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.opened_link.description) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.loading
            ? _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    {
                      staticStyle: { height: "40vh" },
                      attrs: { justify: "center", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _vm.error_order_loading
                            ? _c(
                                "div",
                                {
                                  staticClass: "display-1",
                                  staticStyle: { color: "#808080" },
                                },
                                [_vm._v(" Не удалось загрузить заказы... ")]
                              )
                            : _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: "60",
                                  width: "3",
                                  color: "dark",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "infinity-load",
                {
                  attrs: { next_page: _vm.next_page },
                  on: { loadnext: _vm.onLoadNextOrders },
                },
                [
                  _c(
                    "order-list",
                    [
                      _vm._l(
                        _vm.sorted_collections,
                        function (collection, index) {
                          return _c("shared-collection", {
                            key: collection.id,
                            attrs: { index: index, collection: collection },
                          })
                        }
                      ),
                      _vm._l(_vm.sorted_orders, function (order, index) {
                        return _c("shared-order", {
                          key: order.id,
                          attrs: { index: index, value: order },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
          _c("image-dialog"),
          _c("socket", {
            attrs: {
              name: "Market",
              path: `purchases/market/${_vm.opened_link.purchase}/`,
            },
            on: { onmessage: _vm.onSocketMessage },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }